module.exports = __webpack_public_path__ + "static/img/4.93cac8e4.png";